import { AuthSurfaceProps } from './AuthSurface.props';
import { AuthSurfaceRoot } from './AuthSurface.styles';

const AuthSurface = ({ children, elevation = 0, ...props }: AuthSurfaceProps) => (
  <AuthSurfaceRoot elevation={elevation} {...props}>
    {children}
  </AuthSurfaceRoot>
);

export default AuthSurface;
